/**
 * 接口配额实体
 */

import { useState, useEffect } from 'react';
import { Modal, Input, Row, Col, message, InputNumber } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const { TextArea } = Input;

const MODULENAME = '接口配额';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [groupPrefix, setGroupPrefix] = useState('');
    const [totalTokens, setTotalTokens] = useState(1000000);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setGroupPrefix('');
        setTotalTokens(1000000);
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setGroupPrefix(props.record.group_prefix);
            setTotalTokens(props.record.total_tokens);
        }
    }, [props.record]);


    const ok = () => {
        //  参数校验
        if (groupPrefix === '') {
            messageApi.error('组织前缀不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'quota/tokens' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'group_prefix': groupPrefix,
                'total_tokens': totalTokens,
                'description': description,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={400}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>组织前缀{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={groupPrefix}
                            onChange={(e) => { setGroupPrefix(e.target.value) }}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>令牌配额{rff}</Col>
                    <Col span={24}>
                        <InputNumber
                            value={totalTokens}
                            onChange={(value) => setTotalTokens(value)}
                            disabled={loading}
                            min={100000}
                            max={1000000000}
                            step={100000}
                            style={{ width: '100%' }}
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity